import { ResultItemProps } from 'shared/components/hawksearch/components/ui/Results/ResultItem';
import React, { useEffect, useState } from 'react';
import useShoppingCart, { UseShoppingCart } from 'features/commerce/shopping-cart/useShoppingCart';
import Modal from 'shared/components/Modal';
import { Localizer } from 'services/Localizer';
{
	/*#region HCL*/
}
import { ServerData } from 'services/ServerData';
import { getUserData } from 'services/UserData';
{
	/*#endregion HCL*/
}
import { AddToCartExceptionCode } from 'features/commerce/product-details/types';
import { AddToCartResponse } from 'services/UserData.Commerce';
import AddedToCartAlert from 'features/commerce/store/AddedToCartAlert';
import InlineAlert from 'shared/edit/InlineAlert';
import Spinner from 'shared/components/Spinner';
import { dispatchRocEvent } from 'shared/hooks/useRocEventHandler';
import ShoppingCartSVG from 'shared/components/svg/ShoppingCartSVG';
{
	/* #region HCL */
}
import { PriceDisplayRule } from 'shared-client/types/commerce/display-price';
import { DisplayPrice } from 'shared-client/types/commerce/display-price';
{
	/* #endregion HCL */
}

export default function ProductAddToCart({ item, productPricingAndAvailability }: ResultItemProps) {
	const productId = item.getDocumentValue('unique_id');
	{
		/* #region HCL */
	}
	const guestQuoteEnabled = item.getDocumentValue('product_guestquoteenabled') === 'true';
	const [userIsSignedIn, setUserIsSignedIn] = useState<boolean>(false);
	{
		/* #endregion HCL */
	}
	const [modalOpen, setModalOpen] = useState<boolean>(true);
	const [isLoading, setIsLoading] = useState<boolean>(false);
	const [addToCartResponse, setAddToCartResponse] = useState<AddToCartResponse | null>(null);

	{
		/* #region HCL */
	}
	useEffect(() => {
		getUserData().then((res) => {
			setUserIsSignedIn(res?.data?.summary?.isSignedIn ?? false);
		});
	}, []);

	const displayRuleFromPrice = (): PriceDisplayRule | null => {
		const priceJson = productPricingAndAvailability?.price;
		if (!priceJson) {
			return null;
		}

		try {
			const parsed = JSON.parse(priceJson) as DisplayPrice;
			return parsed?.displayRule ?? null;
		} catch {
			return null;
		}
	};
	const showQuoteLinkInsteadOfAddToCart =
		guestQuoteEnabled && (!userIsSignedIn || displayRuleFromPrice() === PriceDisplayRule.Missing);

	const requestQuoteFormUrl = ServerData.RequestQuoteFormUrl ?? 'https://www.gohcl.com/request-for-quote-form';
	{
		/* #endregion HCL */
	}

	const UseShoppingCartResult: UseShoppingCart = useShoppingCart();
	const {
		state: { errorMessage, errorType },
		actor: { addToCart },
	} = UseShoppingCartResult;

	const errorTitle =
		errorType === AddToCartExceptionCode.cartFull
			? Localizer('CartFull')
			: errorType === AddToCartExceptionCode.productOutOfStock
			? Localizer('OutOfStock')
			: errorType === AddToCartExceptionCode.productUnavailable
			? Localizer('ProductUnavailable')
			: Localizer('ErrorMessageGenericTitle');

	const handleAddToCart = async () => {
		try {
			if (!productId) {
				return;
			}

			setAddToCartResponse(null);
			setIsLoading(true);
			const response = await addToCart({
				itemId: productId,
				quantity: 1,
				productPricingLineId: null,
			});

			setModalOpen(true);
			setIsLoading(false);

			if (!response) {
				setAddToCartResponse(null);
				return;
			}

			dispatchRocEvent('roc-cart-summary-updated', { cartSummary: response.cartSummary });

			setAddToCartResponse(response);
		} catch (error) {
			setAddToCartResponse(null);
		}
	};

	return (
		<>
			<div className="hawk-results__add-to-cart">
				{/* #region HCL */}
				{showQuoteLinkInsteadOfAddToCart ? (
					<a href={requestQuoteFormUrl} target="_blank" rel="noopener noreferrer" className="roc-link">
						{Localizer('PleaseFillOutRequestQuoteHere')}
					</a>
				) : isLoading ? (
					//#endregion HCL
					<div>
						<Spinner align="left" />
						{Localizer('Loading')}
					</div>
				) : (
					<button
						disabled={isLoading || productPricingAndAvailability?.outOfStock}
						className="roc-btn"
						onClick={() => handleAddToCart()}
						key={productId}
					>
						<span>{Localizer('AddToCart')}</span>
						<ShoppingCartSVG />
					</button>
				)}
			</div>

			{addToCartResponse !== null ? (
				<Modal
					isOpen={modalOpen}
					renderTitle={() => Localizer('AddedToCart')}
					closeModal={() => setModalOpen(false)}
					className="addedToCartModal"
				>
					<AddedToCartAlert response={addToCartResponse} />
				</Modal>
			) : null}

			{errorMessage && (
				<Modal isOpen={modalOpen} renderTitle={() => errorTitle} closeModal={() => setModalOpen(false)}>
					<InlineAlert theme="danger" isTitleOnOwnRow message={<>{errorMessage}</>} />
				</Modal>
			)}
		</>
	);
}
